import React from "react";

const quest = [
  {
    category: "Science & Nature",
    type: "multiple",
    difficulty: "easy",
    question: "Which animal is known as the 'Ship of the Desert?",
    correct_answer: "Camel",
    incorrect_answers: ["Lion", "Snake", "Horse"],
  },
  {
    category: "Sports",
    type: "multiple",
    difficulty: "easy",
    question: "Which of the following sports is not part of the triathlon?",
    correct_answer: "Horse-Riding",
    incorrect_answers: ["Cycling", "Swimming", "Running"],
  },
  {
    category: "Entertainment: Cartoon & Animations",
    type: "multiple",
    difficulty: "medium",
    question: "What is Scooby-Doo&#039;s real name?",
    correct_answer: "Scoobert",
    incorrect_answers: ["Scooter", "Scrappy", "Shooby"],
  },
  {
    category: "History",
    type: "multiple",
    difficulty: "medium",
    question:
      "During the Mongolian invasions of Japan, what were the Mongol boats mostly stopped by?",
    correct_answer: "Typhoons",
    incorrect_answers: ["Tornados", "Economic depression", "Samurai"],
  },
  {
    category: "Vehicles",
    type: "multiple",
    difficulty: "medium",
    question:
      "Which animal features on the logo for Abarth, the motorsport division of Fiat?",
    correct_answer: "Scorpion",
    incorrect_answers: ["Snake", "Bull", "Horse"],
  },
  {
    category: "Mythology",
    type: "boolean",
    difficulty: "easy",
    question: "In Norse mythology, Thor once dressed as a woman.",
    correct_answer: "True",
    incorrect_answers: ["False"],
  },
  {
    category: "Entertainment: Film",
    type: "boolean",
    difficulty: "easy",
    question:
      "Han Solo&#039;s co-pilot and best friend, &quot;Chewbacca&quot;, is an Ewok.",
    correct_answer: "False",
    incorrect_answers: ["True"],
  },
  {
    category: "Science & Nature",
    type: "multiple",
    difficulty: "easy",
    question: "What name is given to all baby marsupials?",
    correct_answer: "Joey",
    incorrect_answers: ["Calf", "Pup", "Cub"],
  },
  {
    category: "Celebrities",
    type: "boolean",
    difficulty: "medium",
    question: "Michael Jackson had a pet python named &lsquo;Crusher&rsquo;.",
    correct_answer: "True",
    incorrect_answers: ["False"],
  },
  {
    category: "Science & Nature",
    type: "multiple",
    difficulty: "medium",
    question:
      "To the nearest minute, how long does it take for light to travel from the Sun to the Earth?",
    correct_answer: "8 Minutes",
    incorrect_answers: ["6 Minutes", "2 Minutes", "12 Minutes"],
  },
  {
    category: "Entertainment: Film",
    type: "multiple",
    difficulty: "hard",
    question:
      "What did Alfred Hitchcock use as blood in the film &quot;Psycho&quot;? ",
    correct_answer: "Chocolate syrup",
    incorrect_answers: ["Ketchup", "Red food coloring", "Maple syrup"],
  },
  {
    category: "Entertainment: Music",
    type: "multiple",
    difficulty: "medium",
    question:
      "Which band released songs such as &quot;Electric Feel&quot;, &quot;Kids&quot;, and &quot;Time to Pretend&quot;?",
    correct_answer: "MGMT",
    incorrect_answers: ["Passion Pit", "Phoenix", "Franz Ferdinand"],
  },
  {
    category: "Entertainment: Books",
    type: "boolean",
    difficulty: "easy",
    question: "The book 1984 was published in 1949.",
    correct_answer: "True",
    incorrect_answers: ["False"],
  },
  {
    category: "History",
    type: "boolean",
    difficulty: "medium",
    question: "Brezhnev was the 5th leader of the USSR.",
    correct_answer: "True",
    incorrect_answers: ["False"],
  },
  {
    category: "Science & Nature",
    type: "multiple",
    difficulty: "easy",
    question:
      "Alzheimer&#039;s disease primarily affects which part of the human body?",
    correct_answer: "Brain",
    incorrect_answers: ["Lungs", "Skin", "Heart"],
  },
  {
    category: "Geography",
    type: "multiple",
    difficulty: "medium",
    question:
      "The World Health Organization headquarters is located in which European country?",
    correct_answer: "Switzerland",
    incorrect_answers: ["United Kingdom", "France", "Belgium"],
  },
  {
    category: "History",
    type: "multiple",
    difficulty: "medium",
    question:
      "Which Apollo mission was the last one in NASA&#039;s Apollo program?",
    correct_answer: "Apollo 17",
    incorrect_answers: ["Apollo 13", "Apollo 11", "Apollo 15"],
  },
  {
    category: "Science & Nature",
    type: "multiple",
    difficulty: "medium",
    question:
      "What polymer is used to make CDs, safety goggles and riot shields?",
    correct_answer: "Polycarbonate",
    incorrect_answers: ["Rubber", "Nylon", "Bakelite"],
  },
  {
    category: "Entertainment: Music",
    type: "multiple",
    difficulty: "medium",
    question:
      "What animal is featured on the cover of English electronic music group The Prodigy&#039;s album, &quot;The Fat of the Land&quot;?",
    correct_answer: "Crab",
    incorrect_answers: ["Fox", "Elephant", "Tiger"],
  },
  {
    category: "General Knowledge",
    type: "multiple",
    difficulty: "hard",
    question: "What is the romanized Arabic word for &quot;moon&quot;?",
    correct_answer: "Qamar",
    incorrect_answers: ["Najma", "Kawkab", "Shams"],
  },
  {
    category: "Mythology",
    type: "boolean",
    difficulty: "medium",
    question: "According to Norse mythology, Loki is a mother.",
    correct_answer: "True",
    incorrect_answers: ["False"],
  },
  {
    category: "General Knowledge",
    type: "multiple",
    difficulty: "medium",
    question: "On average, Americans consume 100 pounds of what per second?",
    correct_answer: "Chocolate",
    incorrect_answers: ["Potatoes", "Donuts", "Cocaine"],
  },
  {
    category: "Entertainment: Musicals & Theatres",
    type: "multiple",
    difficulty: "medium",
    question: "What was George Bizet&#039;s last opera?",
    correct_answer: "Carmen",
    incorrect_answers: [
      "Don Rodrigue",
      "Gris&eacute;lidis",
      "Les p&ecirc;cheurs de perles",
    ],
  },
  {
    category: "Entertainment: Video Games",
    type: "multiple",
    difficulty: "medium",
    question: "The creator of the Touhou Project series is:",
    correct_answer: "ZUN",
    incorrect_answers: ["SUN", "RUN", "PUN"],
  },
  {
    category: "Entertainment: Video Games",
    type: "multiple",
    difficulty: "easy",
    question:
      "Which of the following is NOT a summon in the game &quot;South Park: The Stick of Truth&quot;?",
    correct_answer: "Towelie",
    incorrect_answers: ["Jesus", "Mr. Hankey", "Mr. Slave"],
  },
  {
    category: "Entertainment: Music",
    type: "multiple",
    difficulty: "medium",
    question:
      "What was the title of Sakamoto Kyu&#039;s song &quot;Ue o Muite Arukou&quot; (I Look Up As I Walk) changed to in the United States?",
    correct_answer: "Sukiyaki",
    incorrect_answers: ["Takoyaki", "Sushi", "Oden"],
  },
  {
    category: "Entertainment: Video Games",
    type: "boolean",
    difficulty: "easy",
    question:
      "Rebecca Chambers does not appear in any Resident Evil except for the original Resident Evil and the Gamecube remake.",
    correct_answer: "False",
    incorrect_answers: ["True"],
  },
  {
    category: "History",
    type: "multiple",
    difficulty: "medium",
    question:
      "What is the bloodiest event in United States history, in terms of casualties?",
    correct_answer: "Battle of Antietam",
    incorrect_answers: ["Pearl Harbor", "September 11th", "D-Day"],
  },
  {
    category: "Entertainment: Music",
    type: "multiple",
    difficulty: "hard",
    question: "The key of sharps does the key of G# minor contain?",
    correct_answer: "5",
    incorrect_answers: ["3", "7", "0"],
  },
  {
    category: "Entertainment: Music",
    type: "multiple",
    difficulty: "hard",
    question:
      "Who designed the album cover for True Romance, an album by Estelle?",
    correct_answer: "Rebecca Sugar",
    incorrect_answers: ["Matt Burnett", "Ian Jones Quartey", "Ben Leven"],
  },
  {
    category: "Entertainment: Film",
    type: "multiple",
    difficulty: "medium",
    question:
      "Darth Vader&#039;s famous reveal to Luke is iconic. But which of these is the right one?",
    correct_answer: "&quot;No. I am your father.&quot;",
    incorrect_answers: [
      "&quot;Luke, I am your father.&quot;",
      "&quot;You&#039;re wrong. I am your father.&quot;",
      "&quot;The truth is that I am your father.&quot;",
    ],
  },
  {
    category: "General Knowledge",
    type: "boolean",
    difficulty: "medium",
    question:
      "Albert Einstein had trouble with mathematics when he was in school.",
    correct_answer: "False",
    incorrect_answers: ["True"],
  },
  {
    category: "Entertainment: Video Games",
    type: "multiple",
    difficulty: "medium",
    question: "What block in Minecraft has the highest blast resistance?",
    correct_answer: "Barrier",
    incorrect_answers: ["Obsidian", "Bedrock", "Block of Diamond"],
  },
  {
    category: "Entertainment: Cartoon & Animations",
    type: "multiple",
    difficulty: "easy",
    question: "Which of the following is not a Flintstones character?",
    correct_answer: "Lord Rockingham IX",
    incorrect_answers: ["Rockhead Slate", "The Great Gazoo", "Barney Rubble"],
  },
  {
    category: "Entertainment: Video Games",
    type: "multiple",
    difficulty: "medium",
    question: "What level do you have to be to get a service medal on CS:GO?",
    correct_answer: "40",
    incorrect_answers: ["50", "30", "20"],
  },
  {
    category: "History",
    type: "multiple",
    difficulty: "hard",
    question: "When was the city of Rome, Italy founded?",
    correct_answer: "753 BCE",
    incorrect_answers: ["902 BCE", "524 BCE", "697 BCE"],
  },
  {
    category: "Entertainment: Video Games",
    type: "multiple",
    difficulty: "medium",
    question:
      "According to Overwatch&#039;s lore, who was once a member of the Deadlock Gang?",
    correct_answer: "McCree",
    incorrect_answers: ["Roadhog", "Soldier 76", "Junkrat"],
  },
  {
    category: "Entertainment: Television",
    type: "multiple",
    difficulty: "medium",
    question: "Who was the winner of the 2016 WWE Royal Rumble?",
    correct_answer: "Triple H",
    incorrect_answers: ["Roman Reigns", "AJ Styles", "Dean Ambrose"],
  },
  {
    category: "Entertainment: Video Games",
    type: "multiple",
    difficulty: "hard",
    question:
      "Which game in the &quot;Monster Hunter&quot; series introduced the monster &quot;Gobul&quot;?",
    correct_answer: "Monster Hunter Tri",
    incorrect_answers: [
      "Monster Hunter Freedom Unite",
      "Monster Hunter Frontier",
      "Monster Hunter Generations",
    ],
  },
  {
    category: "Entertainment: Video Games",
    type: "multiple",
    difficulty: "medium",
    question:
      "How much did the indie game &quot;Cave Story&quot; cost when it was first released in 2004?",
    correct_answer: "$0 USD",
    incorrect_answers: ["$5 USD", "$10 USD", "$15 USD"],
  },
  {
    category: "Entertainment: Comics",
    type: "multiple",
    difficulty: "easy",
    question:
      "The main six year old protagonist in Calvin and Hobbes is named after what theologian?",
    correct_answer: "John Calvin",
    incorrect_answers: [
      "Calvin Klein",
      "Calvin Coolidge",
      "Phillip Calvin McGraw",
    ],
  },
  {
    category: "Entertainment: Music",
    type: "multiple",
    difficulty: "medium",
    question:
      "In which year was the Megadeth album &quot;Peace Sells... but Who&#039;s Buying?&quot; released?",
    correct_answer: "1986",
    incorrect_answers: ["1979", "1987", "1983"],
  },
  {
    category: "Science & Nature",
    type: "multiple",
    difficulty: "medium",
    question:
      "Down Syndrome is usually caused by an extra copy of which chromosome?",
    correct_answer: "21",
    incorrect_answers: ["23", "15", "24"],
  },
  {
    category: "General Knowledge",
    type: "multiple",
    difficulty: "medium",
    question: "Which country has the most Trappist breweries?",
    correct_answer: "Belgium",
    incorrect_answers: ["Netherlands", "France", "USA"],
  },
  {
    category: "General Knowledge",
    type: "multiple",
    difficulty: "easy",
    question: "What is Cynophobia the fear of?",
    correct_answer: "Dogs",
    incorrect_answers: ["Birds", "Flying", "Germs"],
  },
  {
    category: "Science & Nature",
    type: "boolean",
    difficulty: "easy",
    question:
      "A plant that has a life cycle for more than a year is known as an annual.",
    correct_answer: "False",
    incorrect_answers: ["True"],
  },
  {
    category: "History",
    type: "multiple",
    difficulty: "medium",
    question:
      "What was the name of the planned invasion of Japan towards the end of World War II?",
    correct_answer: "Operation Downfall",
    incorrect_answers: [
      "Operation Boarding Party",
      "Operation Ironclad",
      "Operation Aflame",
    ],
  },
  {
    category: "Sports",
    type: "multiple",
    difficulty: "easy",
    question: "Which country will host the 2022 FIFA World Cup?",
    correct_answer: "Qatar",
    incorrect_answers: ["USA", "Japan", "Switzerland"],
  },
  {
    category: "Mythology",
    type: "multiple",
    difficulty: "medium",
    question:
      "Which greek god/goddess tossed a golden apple with the words &quot;for the fairest&quot; into the middle of the feast of the gods?",
    correct_answer: "Eris",
    incorrect_answers: ["Hades", "Ares", "Artemis"],
  },
  {
    category: "Sports",
    type: "multiple",
    difficulty: "medium",
    question: "Which basketball team has attended the most NBA grand finals?",
    correct_answer: "Los Angeles Lakers",
    incorrect_answers: [
      "Boston Celtics",
      "Philadelphia 76ers",
      "Golden State Warriors",
    ],
  },
  {
    category: "Entertainment: Television",
    type: "multiple",
    difficulty: "easy",
    question:
      "In Two and a Half Men, what is Alan Harper&#039;s son&#039;s name?",
    correct_answer: "Jake",
    incorrect_answers: ["John", "Jeremy", "James"],
  },
];

export default quest;
